import { lazyLoadVideoSrc } from "../../../resources/js/helper/helper";

export default function initLazyLoadingVideos() {
  document.addEventListener("DOMContentLoaded", function () {
    // lazyload videos on click
    let lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

    lazyVideos.forEach(function (lazyVideo) {
      lazyLoadVideoSrc(lazyVideo);
    });

    lazyVideos.forEach(function (video) {
      video.addEventListener("click", function (e) {
        video.paused ? video.play() : video.pause();
      });
    });
  });
}
